import { css, styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import withProps from 'recompose/withProps';
import Layout from '@4c/layout';

import bflyIcon from '../assets/bfly-icon-white.svg';
import facebook from '../assets/social/facebook.png';
import instagram from '../assets/social/instagram.svg';
import linkedin from '../assets/social/linkedin.png';
import twitter from '../assets/social/twitter.png';
import youtube from '../assets/social/youtube.png';
import PageSegment from './PageSegment';

const styles = require('./Footer-styles.module.scss');

const Block = styled('div', null, "Block", require("./Footer-Block.module.scss"), "block", "block");

const Title = styled('div', null, "Title", require("./Footer-Title.module.scss"), "title", "title");

const FooterLink = withProps({ as: 'a', align: 'center' })(
  styled(Layout, null, "FooterLink", require("./Footer-FooterLink.module.scss"), "footer-link", "footerLink"),
);

function Footer() {
  return (
    <PageSegment className={styles.footer} theme="dark">
      <Layout wrap className={styles.wrap}>
        <Block desktopOnly>
          <a href="https://www.butterflynetwork.com" className={styles.logo}>
            <img src={bflyIcon} alt="Home" />
          </a>
        </Block>
        <Block>
          <Title>
            <FormattedMessage
              defaultMessage="Butterfly iQ"
              id="footer.iq.title"
            />
          </Title>
          <FooterLink href="https://www.butterflynetwork.com/iq">
            <FormattedMessage defaultMessage="Product" id="footer.iq" />
          </FooterLink>
          <FooterLink href="https://www.butterflynetwork.com/technology">
            <FormattedMessage defaultMessage="Tech" id="footer.tech" />
          </FooterLink>
          <FooterLink href="https://www.butterflynetwork.com/clinical">
            <FormattedMessage defaultMessage="Clinical" id="footer.clinical" />
          </FooterLink>

          <FooterLink href="https://www.butterflynetwork.com/specs">
            <FormattedMessage defaultMessage="Specs" id="footer.specs" />
          </FooterLink>

          <FooterLink href="https://www.butterflynetwork.com/faq">
            <FormattedMessage defaultMessage="FAQ" id="footer.faq" />
          </FooterLink>

          <FooterLink href="https://www.butterflynetwork.com/testimonials">
            <FormattedMessage
              defaultMessage="Testimonials"
              id="footer.testimonials"
            />
          </FooterLink>

          <FooterLink href="https://www.butterflynetwork.com/reserve">
            <FormattedMessage
              defaultMessage="Reserve now"
              id="footer.reserve"
            />
          </FooterLink>
        </Block>
        <Block>
          <Title>
            <FormattedMessage defaultMessage="Company" id="footer.company" />
          </Title>

          <FooterLink href="https://www.butterflynetwork.com/about">
            <FormattedMessage defaultMessage="About" id="footer.about" />
          </FooterLink>
          <FooterLink href="https://careers.smartrecruiters.com/4Catalyzer/butterfly-network">
            <FormattedMessage defaultMessage="Careers" id="footer.careers" />
          </FooterLink>
          <FooterLink href="https://www.butterflynetwork.com/patents">
            <FormattedMessage defaultMessage="Patents" id="footer.patents" />
          </FooterLink>
          <FooterLink href="https://www.butterflynetwork.com/press">
            <FormattedMessage defaultMessage="Press" id="footer.press" />
          </FooterLink>
          <FooterLink href="https://www.butterflynetwork.com/contact">
            <FormattedMessage defaultMessage="Contact" id="footer.contact" />
          </FooterLink>
          <FooterLink href="https://www.butterflynetwork.com/privacy-policy">
            <FormattedMessage
              defaultMessage="Privacy Policy"
              id="footer.privacy-policy"
            />
          </FooterLink>
          <FooterLink href="https://www.butterflynetwork.com/terms-of-use">
            <FormattedMessage
              defaultMessage="Terms of Use"
              id="footer.termsofuse"
            />
          </FooterLink>
        </Block>
        <Block>
          <Title>
            <FormattedMessage
              defaultMessage="Follow us"
              id="footer.socialMedia"
            />
          </Title>
          <FooterLink href="https://twitter.com/ButterflyNetInc">
            <img className={styles.img} src={twitter} alt="" />
            <FormattedMessage defaultMessage="Twitter" id="footer.twitter" />
          </FooterLink>
          <FooterLink href="https://www.instagram.com/butterflynetwork/">
            <img className={styles.img} src={instagram} alt="" />
            <FormattedMessage
              defaultMessage="Instagram"
              id="footer.instagram"
            />
          </FooterLink>
          <FooterLink href="https://www.youtube.com/channel/UClOdXzqDR9Bd8llD_tX4FrA">
            <img className={styles.img} src={youtube} alt="" />
            <FormattedMessage defaultMessage="Youtube" id="footer.youtube" />
          </FooterLink>
          <FooterLink href="https://www.facebook.com/butterflynetinc/">
            <img className={styles.img} src={facebook} alt="" />
            <FormattedMessage defaultMessage="Facebook" id="footer.facebook" />
          </FooterLink>
          <FooterLink href="https://www.linkedin.com/company/2338924/">
            <img className={styles.img} src={linkedin} alt="" />
            <FormattedMessage defaultMessage="LinkedIn" id="footer.linkedin" />
          </FooterLink>
        </Block>
      </Layout>
      <small>© 2018 Butterfly Network, Inc.</small>
    </PageSegment>
  );
}

export default Footer;
